<div class="input-group" [ngClass]="size ? 'input-group-' + size : null">
  <input
    type="number"
    class="form-control text-end"
    [class.is-invalid]="showError"
    [(ngModel)]="model"
    [min]="min"
    [max]="max"
    [disabled]="isDisabled"
    (ngModelChange)="onChange($event)"
    (blur)="onBlur()"
    [placeholder]="placeholder"
    [readonly]="readOnly"
  />
  <div class="input-group-text rounded-end">%</div>
  <ng-content></ng-content>
</div>
